export interface FormValue {
  city?: string;
  postal?: string;
  state?: string;
  address1?: string;
  address2?: string;
  countryCode?: string;
  label?: string;
}

export interface AddressModel {
  city?: string;
  id?: number;
  postalCode?: string;
  state?: string;
  street1?: string;
  street2?: string;
  countryCode?: string;
  label?: string;
}

export function formValueToModel({
  address1,
  address2,
  city,
  state,
  postal,
  countryCode,
  label,
}: FormValue) {
  // But if any data is provided, then we intend to send _some_ address.
  return {
    street1: address1,
    street2: address2,
    city,
    state: state || '',
    postalCode: postal,
    countryCode: countryCode || undefined,
    label: label,
  };
}

export function formValueToModelNullable(value: FormValue) {
  // We return `undefined` in this function because of typescript constraints;
  // but when we ask the server to delete the address,
  // we want to send `null` instead of `undefined`.
  if (!value.address1 && !value.address2 && !value.city && !value.postal) {
    return undefined;
  } else {
    return formValueToModel(value);
  }
}

// There is no guarantee that the model will not be null
export function modelToFormValue(model: AddressModel | null) {
  const { street1, street2, city, state, postalCode, countryCode, label } =
    model || {};

  return {
    address1: street1 || '',
    address2: street2 || '',
    city,
    state,
    postal: postalCode,
    countryCode,
    label,
  };
}

export function modelToFormValueNullable(model: AddressModel | null) {
  if (!model) {
    return null;
  } else {
    return modelToFormValue(model);
  }
}
